import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// material
import { styled, useTheme } from '@mui/material/styles';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import { fetchSchoolData } from '../../redux/slices/merchant';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 64;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  backgroundColor: '#FDFFFD'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  backgroundColor: '#f8fafc',
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: 0,
    paddingRight: 0
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  // QB editor sticky top bar needs viewport overflow visible on question routes.
  const usesViewportSticky =
    pathname.startsWith('/dashboard/internal-question-bank/questions') ||
    pathname.startsWith('/dashboard/aplus-question-bank/questions');
  useEffect(() => {
    dispatch(fetchSchoolData({}));
  }, []);

  return (
    <RootStyle sx={{ overflow: usesViewportSticky ? 'visible' : 'hidden' }}>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle
        sx={{
          overflow: usesViewportSticky ? 'visible' : 'auto',
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && {
            ml: '102px'
          })
        }}
      >
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
